import { cdnOrigin, reportingOrigin } from 'lib/utils';

export const makeApiUrl = (path: string): string => `${reportingOrigin()}${path}`;

export const makeCdnUrl = (path: string): string => `${cdnOrigin()}${path}`;
